import { reducer as education } from "./education/slice";

export const reducer = {
  education,
};
